import { render, staticRenderFns } from "./returnvisitRecord.vue?vue&type=template&id=a4aa25c0&scoped=true&"
import script from "./returnvisitRecord.vue?vue&type=script&lang=js&"
export * from "./returnvisitRecord.vue?vue&type=script&lang=js&"
import style0 from "./returnvisitRecord.vue?vue&type=style&index=0&id=a4aa25c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aa25c0",
  null
  
)

export default component.exports